{
  "failLoadDxmlFile": "(500) Failed to load DXML file",
  "failSaveDocument": "(501) Failed to save document",
  "failLoadFile": "(502) Failed to load file",
  "failLoadData": "(503) Failed to load data",
  "failSearch": "(504) Failed to search",
  "failSearchAttachment": "(505) Failed to search attachment",
  "failLoadFileExtension": "(506) Failed to load file because file extension ",
  "failLoadFileExtensionIsNotSupport": " is not supported.",
  "disableDistributionError": "(507) It can not publish document. Please disable distribution in the WebEditor settings in the CenterPoint.",
  "enableDistributionError": "(508) It can not publish document. Please enable distribution in the WebEditor settings in the CenterPoint.",
  "selectFileTooLarge": "(509) The selected file is too large. The maximum file size is 1MB.",
  "inactiveDistributionList": "(510) The distribution list in the Pages manager is not activated.",
  "noActiveDistributionAlternatives": "(511) The distribution list in the Page manager doesn't have any active distribution alternatives.",
  "publishErrorMsg": "(513) The document cannot be published due to invalid or incomplete information in one or more fields."
}